/**
 * @generated SignedSource<<4de351a652f7c3de19b08dc25533bfec>>
 * @relayHash 7c7cb9b2c98c8c85758b2cdb4d5d70bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 29bfb9c4f94ceb54eec45c6e276141c5f31cdbd6859172683a71e348762376bd

import type { ConcreteRequest, Query } from 'relay-runtime';
export type utilsOpsgenieTeamScheduleQuery$variables = {
  endTime: AGG$DateTime;
  startTime: AGG$DateTime;
  teamId: string;
};
export type utilsOpsgenieTeamScheduleQuery$data = {
  readonly opsgenie: {
    readonly opsgenieTeam: {
      readonly id: string;
      readonly schedules: ReadonlyArray<{
        readonly enabled: boolean;
        readonly finalTimeline: {
          readonly endDate: AGG$DateTime;
          readonly rotations: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly order: number;
            readonly periods: ReadonlyArray<{
              readonly endDate: AGG$DateTime;
              readonly recipient: {
                readonly type: string;
                readonly user: {
                  readonly accountId: string;
                  readonly name: string;
                } | null | undefined;
              };
              readonly startDate: AGG$DateTime;
              readonly type: string;
            } | null | undefined> | null | undefined;
          } | null | undefined> | null | undefined;
          readonly startDate: AGG$DateTime;
        };
        readonly id: string;
        readonly name: string;
        readonly timezone: string;
      } | null | undefined> | null | undefined;
    };
  };
};
export type utilsOpsgenieTeamScheduleQuery = {
  response: utilsOpsgenieTeamScheduleQuery$data;
  variables: utilsOpsgenieTeamScheduleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTime"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "enabled"
},
v7 = {
  "kind": "ScalarField",
  "name": "timezone"
},
v8 = [
  {
    "kind": "Variable",
    "name": "endTime",
    "variableName": "endTime"
  },
  {
    "kind": "Variable",
    "name": "startTime",
    "variableName": "startTime"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v10 = {
  "kind": "ScalarField",
  "name": "endDate"
},
v11 = {
  "kind": "ScalarField",
  "name": "order"
},
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "utilsOpsgenieTeamScheduleQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "OpsgenieQuery",
          "kind": "LinkedField",
          "name": "opsgenie",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "concreteType": "OpsgenieTeam",
                "kind": "LinkedField",
                "name": "opsgenieTeam",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v4/*: any*/),
                    "action": "THROW",
                    "path": "opsgenie.opsgenieTeam.id"
                  },
                  {
                    "concreteType": "OpsgenieSchedule",
                    "kind": "LinkedField",
                    "name": "schedules",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v4/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.opsgenieTeam.schedules.id"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v5/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.opsgenieTeam.schedules.name"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v6/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.opsgenieTeam.schedules.enabled"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v7/*: any*/),
                        "action": "THROW",
                        "path": "opsgenie.opsgenieTeam.schedules.timezone"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "args": (v8/*: any*/),
                          "concreteType": "OpsgenieScheduleTimeline",
                          "kind": "LinkedField",
                          "name": "finalTimeline",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v9/*: any*/),
                              "action": "THROW",
                              "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.startDate"
                            },
                            {
                              "kind": "RequiredField",
                              "field": (v10/*: any*/),
                              "action": "THROW",
                              "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.endDate"
                            },
                            {
                              "concreteType": "OpsgenieScheduleRotation",
                              "kind": "LinkedField",
                              "name": "rotations",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": (v4/*: any*/),
                                  "action": "THROW",
                                  "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.id"
                                },
                                {
                                  "kind": "RequiredField",
                                  "field": (v5/*: any*/),
                                  "action": "THROW",
                                  "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.name"
                                },
                                {
                                  "kind": "RequiredField",
                                  "field": (v11/*: any*/),
                                  "action": "THROW",
                                  "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.order"
                                },
                                {
                                  "concreteType": "OpsgenieSchedulePeriod",
                                  "kind": "LinkedField",
                                  "name": "periods",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v9/*: any*/),
                                      "action": "THROW",
                                      "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.periods.startDate"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v10/*: any*/),
                                      "action": "THROW",
                                      "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.periods.endDate"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v12/*: any*/),
                                      "action": "THROW",
                                      "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.periods.type"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "concreteType": "OpsgenieSchedulePeriodRecipient",
                                        "kind": "LinkedField",
                                        "name": "recipient",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": (v12/*: any*/),
                                            "action": "THROW",
                                            "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.periods.recipient.type"
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "RequiredField",
                                                "field": (v13/*: any*/),
                                                "action": "THROW",
                                                "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.periods.recipient.user.accountId"
                                              },
                                              {
                                                "kind": "RequiredField",
                                                "field": (v5/*: any*/),
                                                "action": "THROW",
                                                "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.periods.recipient.user.name"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "opsgenie.opsgenieTeam.schedules.finalTimeline.rotations.periods.recipient"
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "opsgenie.opsgenieTeam.schedules.finalTimeline"
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "opsgenie.opsgenieTeam"
            }
          ]
        },
        "action": "THROW",
        "path": "opsgenie"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "utilsOpsgenieTeamScheduleQuery",
    "selections": [
      {
        "concreteType": "OpsgenieQuery",
        "kind": "LinkedField",
        "name": "opsgenie",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "OpsgenieTeam",
            "kind": "LinkedField",
            "name": "opsgenieTeam",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "OpsgenieSchedule",
                "kind": "LinkedField",
                "name": "schedules",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "OpsgenieScheduleTimeline",
                    "kind": "LinkedField",
                    "name": "finalTimeline",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "concreteType": "OpsgenieScheduleRotation",
                        "kind": "LinkedField",
                        "name": "rotations",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v11/*: any*/),
                          {
                            "concreteType": "OpsgenieSchedulePeriod",
                            "kind": "LinkedField",
                            "name": "periods",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v12/*: any*/),
                              {
                                "concreteType": "OpsgenieSchedulePeriodRecipient",
                                "kind": "LinkedField",
                                "name": "recipient",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                      },
                                      (v13/*: any*/),
                                      (v5/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  },
                                  (v4/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "29bfb9c4f94ceb54eec45c6e276141c5f31cdbd6859172683a71e348762376bd",
    "metadata": {},
    "name": "utilsOpsgenieTeamScheduleQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "108cfdf905747803b623f07ae9364d28";

export default node;
